import {I18nKeyEnum} from './language.model';

export enum SupportedLanguagesEnum {
    DE = 'de',
    EN = 'en'
}

export enum SupportedGenderEnum {
    ANY = 'any',
    MALE = 'male',
    FEMALE = 'female',
}

export enum SupportedAgeEnum {
    ANY = 'any',
    YOUNG = 'young',
    MIDDLE_AGED = 'middle_aged',
    OLD = 'old',
}

export const voiceBotLanguages: VoiceBotLanguage[] = [
    {i18nKey: I18nKeyEnum.GERMAN, shortName: SupportedLanguagesEnum.DE},
    {i18nKey: I18nKeyEnum.ENGLISH, shortName: SupportedLanguagesEnum.EN}
];

export const voiceBotGenders: VoiceBotGender[] = [
    {i18nKey: I18nKeyEnum.ANY, shortName: SupportedGenderEnum.ANY},
    {i18nKey: I18nKeyEnum.MALE, shortName: SupportedGenderEnum.MALE},
    {i18nKey: I18nKeyEnum.FEMALE, shortName: SupportedGenderEnum.FEMALE},
]

export const voiceBotAges: VoiceBotAge[] = [
    {i18nKey: I18nKeyEnum.ANY, shortName: SupportedAgeEnum.ANY},
    {i18nKey: I18nKeyEnum.YOUNG, shortName: SupportedAgeEnum.YOUNG},
    {i18nKey: I18nKeyEnum.MIDDLE_AGED, shortName: SupportedAgeEnum.MIDDLE_AGED},
    {i18nKey: I18nKeyEnum.OLD, shortName: SupportedAgeEnum.OLD},
]

export interface VoiceBotLanguage {
    i18nKey: I18nKeyEnum;
    shortName: SupportedLanguagesEnum;
}

export interface VoiceBotGender {
    i18nKey: I18nKeyEnum;
    shortName: SupportedGenderEnum;
}

export interface VoiceBotAge {
    i18nKey: I18nKeyEnum;
    shortName: SupportedAgeEnum;
}

export interface VoiceBotType {
    name: string,
    description: string,
    labels: {
        language: string,
        accent: string,
        description: string,
        age: string,
        use_case: string,
        gender: string,
    },
    voice_id: string,
    preview_url: string,
    fine_tuning: {
        language: string,
        state: {
            eleven_multilingual_v2: string
        }
    }
}

export interface SummarySubElement {
    content: string;
    subtitle: string;
}

export interface SummaryElement {
    title: string,
    subtitles?: SummarySubElement[],
}

export interface LlmProperty {
    description: string;
    type: string;
}

export interface FunctionProperty {
    description: string;
    display_name: string;
    name: string;
    type: string;
}

export interface LLM_function {
    description: string;
    name: string;
    parameters: {
        properties: {
            [key: string]: LlmProperty;
        }
        required: string[],
        type: object
    };
}

interface function_definition {
    description: string;
    display_name: string;
    name: string;
    parameters: {
        properties: FunctionProperty[],
        required: string[],
        type: object
    };
}

export interface CallScenario {
    function_definition: function_definition,
    llm_function: LLM_function;
    tool_id: number
}


